import { createSelector } from '@ngrx/store';

import * as fromBuilding from '../reducers/building.reducers'
import * as fromRoot from '../reducers'

export const selectBuildings = createSelector(fromRoot.selectBuildingState, fromBuilding.getBuildings);
export const selectBuildingLevels = createSelector(fromRoot.selectBuildingState, fromBuilding.getBuildingLevels);
export const selectBuildingUnits = createSelector(fromRoot.selectBuildingState, fromBuilding.getBuildingUnits);
export const selectAllBuildingUnits = createSelector(fromRoot.selectBuildingState, fromBuilding.getAllBuildingUnits);



// WEBPACK FOOTER //
// ./src/app/core/store/selectors/building.selectors.ts